import UserPreferences from '@/Client/Model/UserPreferences';

export default {
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$store.commit('resetState');
        this.$store.dispatch('logout');

        const companyLogin = UserPreferences.getCompanyLogin();
        if (companyLogin) {
          this.$router.push({name: 'companyLogin', params: {company: companyLogin.name}});
        } else {
          this.$router.push({name: 'login'});
        }
      });
    },
  },
};
